import { applyTimezone, getDateOnly, parseDate } from '../helpers/date';
import { parseNumeric } from './../helpers/number';

export function parseInvoiceTransaction(data: any) {
  if (data) {
    return new InvoiceTransaction(data);
  }
}

export class InvoiceTransaction {
  amount: number;
  id: string;
  paidIn: Date;
  fineAmount: number;
  interestAmount: number;

  constructor(data: string | InvoiceTransaction | DjangoInvoiceTransaction = {}) {
    if (typeof data === 'string') {
      bindInvoiceTransaction(this, { id: data });
    } else {
      bindInvoiceTransaction(this, data);
    }
  }

  static toDjango(data: InvoiceTransaction): DjangoInvoiceTransaction {
    return {
      id: data.id,
      amount: data.amount,
      paid_in: getDateOnly(data.paidIn),
      fine_amount: data.fineAmount,
      interest_amount: data.interestAmount,
    };
  }
}

function bindInvoiceTransaction(
  invoicseTransaction: InvoiceTransaction,
  data: InvoiceTransaction | DjangoInvoiceTransaction,
) {
  const jsData = bindDjangoPropsToJs(data);
  invoicseTransaction.amount = parseNumeric(jsData.amount);
  invoicseTransaction.id = jsData.id;
  invoicseTransaction.paidIn = parseDate(jsData.paidIn);
  invoicseTransaction.fineAmount = parseNumeric(jsData.fineAmount);
  invoicseTransaction.interestAmount = parseNumeric(jsData.interestAmount);
}

function bindDjangoPropsToJs(data: InvoiceTransaction | DjangoInvoiceTransaction) {
  const djangoData = data as DjangoInvoiceTransaction;
  const jsData = data as InvoiceTransaction;
  return {
    ...data,
    paidIn: jsData.paidIn || applyTimezone(parseDate(djangoData.paid_in), 0),
    fineAmount: djangoData.fine_amount || jsData.fineAmount,
    interestAmount: djangoData.interest_amount || jsData.interestAmount,
  } as InvoiceTransaction;
}

////////////////////
// DJANGO SUPPORT //
////////////////////
export interface DjangoInvoiceTransaction {
  amount?: number;
  id?: string;
  paid_in?: string;
  fine_amount?: number;
  interest_amount?: number;
}
